import React, { useContext, useState, useEffect } from "react";
import Header from "../../header2/index-two";
import { AppContext } from "../../../services/AuthContext";
import { saveUserSettingAndUpdate, getUserSettingDetail } from "../../../services/userService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Footer2 } from "../../footer2";
import SettingsPageHeader from "./settingsPageHeader";

const UserSettings = () => {
  const { auth } = useContext(AppContext);

  const [formData, setFormData] = useState({
    bibliographicreferenceformat: '',
    downloadformat: '',
    emailformat: '',
    resultsformat: '',
    searcharea: '',
    searchhistoryenabled: '',
    searchresultssizeperpage: 0,
    sortfield: '',
    sortorder: '',
    status: 0,
    addeddate: '',
    updatedate: ''
  });

  useEffect(() => {
    const fetchUserSettings = async () => {
      try {
        const response = await getUserSettingDetail(auth.id, auth.token);
        setFormData(response.data);
      } catch (error) {
        // toast.error("Error fetching user settings.");
      }
    };
    fetchUserSettings();
  }, [auth]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await saveUserSettingAndUpdate({
        userid: auth.id,
        ...formData
      }, auth.token);
      toast.success(response.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      toast.error("Failed to update settings.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  return (
    <div className="main-wrapper bg-body-tertiary min-vh-100">
      <Header activeMenu={"Settings"} />
      <div className="container py-5 mt-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10 mx-auto">
            <div className="bg-white rounded-4 shadow-sm p-4">
              <h4 className="fw-semibold text-darkfume text-center border-bottom pb-2 mb-4">Kullanıcı Ayarları</h4>
              <SettingsPageHeader />
              <form onSubmit={handleSubmit}>
                <div className="row g-3 mt-2">
                  <div className="col-md-6">
                    <label className="text-sm text-darkfume mt-2">Bibliographic Reference Format</label>
                    <select
                      className="form-control text-fume"
                      name="bibliographicreferenceformat"
                      value={formData.bibliographicreferenceformat}
                      onChange={handleChange}
                    >
                      <option value="">Select Format</option>
                      <option value="APA">APA</option>
                      <option value="MLA">MLA</option>
                      <option value="Chicago">Chicago</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="text-sm text-darkfume">Download Format</label>
                    <select
                      className="form-control text-fume"
                      name="downloadformat"
                      value={formData.downloadformat}
                      onChange={handleChange}
                    >
                      <option value="">Select Format</option>
                      <option value="PDF">PDF</option>
                      <option value="Word">Word</option>
                      <option value="Excel">Excel</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="text-sm text-darkfume">Email Format</label>
                    <select
                      className="form-control text-fume"
                      name="emailformat"
                      value={formData.emailformat}
                      onChange={handleChange}
                    >
                      <option value="">Select Format</option>
                      <option value="HTML">HTML</option>
                      <option value="Plain Text">Plain Text</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="text-sm text-darkfume">Results Format</label>
                    <select
                      className="form-control text-fume"
                      name="resultsformat"
                      value={formData.resultsformat}
                      onChange={handleChange}
                    >
                      <option value="">Select Format</option>
                      <option value="List">List</option>
                      <option value="Grid">Grid</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="text-sm text-darkfume">Search Area</label>
                    <input
                      type="text"
                      className="form-control text-fume"
                      name="searcharea"
                      value={formData.searcharea}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="text-sm text-darkfume">Search History Enabled</label>
                    <select
                      className="form-control text-fume"
                      name="searchhistoryenabled"
                      value={formData.searchhistoryenabled}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="true">Evet</option>
                      <option value="false">Hayır</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="text-sm text-darkfume">Results Per Page</label>
                    <input
                      type="number"
                      className="form-control text-fume"
                      name="searchresultssizeperpage"
                      value={formData.searchresultssizeperpage}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="text-sm text-darkfume">Sort Field</label>
                    <input
                      type="text"
                      className="form-control text-fume"
                      name="sortfield"
                      value={formData.sortfield}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="text-sm text-darkfume">Sort Order</label>
                    <input
                      type="text"
                      className="form-control text-fume"
                      name="sortorder"
                      value={formData.sortorder}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-12 text-center mt-3">
                    <button className="btn btn-info btn-sm rounded-4 px-4 py-2 text-white fw-bold" type="submit">
                      Ayarları Kaydet
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer2 />
      <ToastContainer />
    </div>
  );
};

export default UserSettings;
